import FetchUserInfo from "./FetchUserInfo";


export default function CheckLogin(props) {
    return <FetchUserInfo>{props.children}</FetchUserInfo>
}
